import { render, staticRenderFns } from "./FeatureDetail.vue?vue&type=template&id=7d1221e9&scoped=true"
import script from "./FeatureDetail.vue?vue&type=script&lang=js"
export * from "./FeatureDetail.vue?vue&type=script&lang=js"
import style0 from "./FeatureDetail.vue?vue&type=style&index=0&id=7d1221e9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d1221e9",
  null
  
)

export default component.exports